import { Permission } from '@jiaofa/constants'

const editToViewPermissions: Record<string, string> = {
  [Permission.DashboardEdit]: Permission.DashboardView,
  [Permission.OrderEdit]: Permission.OrderView,
  [Permission.RefundEdit]: Permission.RefundView,
  [Permission.StoreEdit]: Permission.StoreView,
  [Permission.ProductEdit]: Permission.ProductView,
  [Permission.DeliveryEdit]: Permission.DeliveryView,
  [Permission.DroneEdit]: Permission.DroneView,
  [Permission.UserEdit]: Permission.UserView,
  [Permission.MemberEdit]: Permission.MemberView,
  [Permission.MarketingEdit]: Permission.MarketingView,
  [Permission.DataEdit]: Permission.DataView,
  [Permission.FinanceEdit]: Permission.FinanceView,
  [Permission.MessageEdit]: Permission.MessageView,
  [Permission.SystemEdit]: Permission.SystemView,
  [Permission.SystemRoleEdit]: Permission.SystemRoleView,
}

export const expandImplicitPermissions = (permissions: readonly string[]): string[] => {
  const expanded = new Set(permissions.filter(Boolean))
  permissions.forEach((permission) => {
    const viewPermission = editToViewPermissions[permission]
    if (viewPermission) expanded.add(viewPermission)
  })
  return [...expanded]
}

